/**
 * Task titles as people should read them. Older generators saved the
 * client-request marker, "Touch <client> — 3 days since last contact" (the row
 * already names the client, and the day count was true the day it was written,
 * in July) and em dashes. The work queue, its task editor and both project
 * boards show titles through this one function. routes/standup.js keeps a
 * server copy of the same rules for the standup text.
 *
 * No imports, so node --test can load this file directly.
 */
export const cleanTitle = (t: string) =>
  String(t || "")
    .replace(/^\[Client Request\]\s*/i, "")
    .replace(/^Touch .+? — .*since last contact$/, "Contact check-in")
    .replace(/^Touch .+? — /, "Contact check-in: ")
    .replace(/ — /g, ": ");
